import { create } from 'zustand'

interface VirtualBadgeStoreState {
	isOpen: boolean
	open: () => void
	setOpen: (isOpen: boolean) => void
}

// Header e user-menu abrem o mesmo modal do crachá virtual
export const useVirtualBadgeStore = create<VirtualBadgeStoreState>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	setOpen: (isOpen) => set({ isOpen }),
}))
